module.exports = __webpack_public_path__ + "img/logo-hotel.097785c2.svg";